import { addNewRelicPageAction } from 'ddc-new-relic';

const doPixallCookies = ({ win: { DDC, jQuery } }) => {
	if (
		!jQuery.cookie('ddc_abc_cache') ||
		jQuery.cookie('ddc_abc_cache') === '[object Object]' ||
		!jQuery.cookie('ddc_abcamm_cache')
	) {
		const pixallCookieUrlReady = new Promise((resolve, reject) => {
			if (DDC?.Widgets?.Tracking?.Pixall?.properties?.pixallCookieUrl) {
				resolve();
			}

			let interval;
			const timeout = setTimeout(() => {
				clearInterval(interval);
				reject();
			}, 5000);
			interval = setInterval(() => {
				if (
					DDC?.Widgets?.Tracking?.Pixall?.properties?.pixallCookieUrl
				) {
					clearInterval(interval);
					clearTimeout(timeout);
					resolve();
				}
			}, 10);
		});
		pixallCookieUrlReady.then(
			() => {
				// Go to the pixall domain and grab the abc cookie value so we can set that cookie on the DDC domain
				jQuery.ajax({
					// url: "$!configuration.getConfigProperty('pixall.cookie.url', '/pixall/cookie')",
					url: DDC.Widgets.Tracking.Pixall.properties.pixallCookieUrl,
					xhrFields: {
						//  With this enabled Server hand shakes with header:
						// 'Access-Control-Allow-Credentials: true' to allow cookie access.
						withCredentials: true
					},
					success: (data) => {
						const eoCookieExists = !!jQuery.cookie('ddc_abc_cache');
						const adCookies = ['abc', 'abcc', 'abcamm', 'abcg'];
						for (let i = adCookies.length - 1; i >= 0; i--) {
							const cookie = adCookies[i];
							// This is how the code was in cms-web, it ends up writing out 4 cookies some with empty values
							// eslint-disable-next-line valid-typeof
							if (typeof data[cookie] !== undefined) {
								const expirationDays =
									data[cookie] === '' ? 1 : 7;
								jQuery.cookie(
									`ddc_${cookie}_cache`,
									data[cookie],
									{
										expires: expirationDays,
										path: '/'
									}
								);
							}
						}
						if (data.abc) {
							// If we got a valid pixallId back, set flag in session storage for widget diagnostics
							sessionStorage.setItem('pixallCookieIsSet', true);
						}
						// If EO cookie was written for first time
						if (!eoCookieExists && jQuery.cookie('ddc_abc_cache')) {
							// Write global value for EO widgets
							// eslint-disable-next-line no-param-reassign
							DDC.tracking = DDC.tracking || {};
							// eslint-disable-next-line no-param-reassign
							DDC.tracking.ddc_abc_cache = data.abc;
							jQuery.publish('ddc-eo-cookies-set');
						}
					}
				});
			},
			() => {
				addNewRelicPageAction('wsTaggingPixallCookieUrlMissing');
			}
		);
	}
};

export default doPixallCookies;
